import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useCallback,
  useRef,
  memo,
} from "react";
import InputMask from "react-input-mask"; // 추가된 임포트

import type { CustomCellEditorProps } from "ag-grid-react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useGridCellEditor } from "ag-grid-react";

interface MaskEditCellEditorProps extends CustomCellEditorProps {
  // ag-Grid가 이 커스텀 에디터를 사용할 때 전달할 추가 props
  maskType: "password" | "business" | "phone" | "postal" | string;
}

export const PassEditCellEditor = memo(
  ({
    value,
    onValueChange,
    eventKey,
    column,
    maskType,
  }: MaskEditCellEditorProps) => {
    const updateValue = (val: string) => {
      onValueChange(val === "" ? null : val);
    };

    useEffect(() => {
      let startValue;

      if (eventKey === "Backspace") {
        startValue = "";
      } else if (eventKey && eventKey.length === 1) {
        startValue = eventKey;
      } else {
        startValue = value;
      }
      if (startValue == null) {
        startValue = "";
      }

      updateValue(startValue);

      refInput.current?.focus();
    }, []);

    const refInput = useRef<HTMLInputElement>(null);

    return (
      <input
        type="password"
        value={value || ""}
        ref={refInput}
        onChange={(event) => updateValue(event.target.value)}
        className="my-simple-editor"
      />
    );
  }
);

export const DateBoxCellEditor = memo(
  ({ value, onValueChange }: CustomCellEditorProps) => {
    const [open, setOpen] = useState(false); // 달력 열림 상태
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [internalValue, setInternalValue] = useState<Dayjs | null>(
      value ? dayjs(value) : null
    );

    const handleClick = () => {
      setOpen(true); // 클릭했을 때만 달력 오픈
    };
    useEffect(() => {
      const input = wrapperRef.current?.querySelector(
        "input"
      ) as HTMLInputElement | null;
      if (!input) return;

      input.focus();
      setOpen(true);
    }, []);

    const handleChange = (newValue: Dayjs | null) => {
      setInternalValue(newValue);
      onValueChange(newValue ? newValue.format("YYYYMMDD") : "");
    };
    const handleClose = () => {
      setOpen(false); // 날짜 선택 없이도 닫힘
    };

    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div ref={wrapperRef}>
          <DatePicker
            format="YYYY/MM/DD"
            // value={value ? dayjs(value) : null}
            value={internalValue}
            onError={() => {}}
            open={open}
            onClose={handleClose}
            onChange={handleChange}
            slotProps={{
              textField: {
                error: false, // 에러 상태 비활성화
                helperText: "", // 헬퍼 텍스트 제거
                InputProps: {
                  endAdornment: null, // 달력 아이콘 제거
                },
                onClick: handleClick, // 클릭 시 달력 열기
              },
            }}
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                height: "32px", // ag-grid 기본 rowHeight 고려
                fontSize: "12px",
                padding: 0,
                alignItems: "center", // 세로 정렬
                display: "flex",
              },
              "& .MuiInputBase-input": {
                padding: "0 8px",
                lineHeight: "normal",
                fontSize: "12px",
              },
              "& .MuiOutlinedInput-root": {
                border: "none", // 테두리 제거
                padding: 0,
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none", // 기본 테두리 제거
              },
              "& .MuiSvgIcon-root": {
                display: "none", // 달력 아이콘 숨기기
              },
            }}
          />
        </div>
      </LocalizationProvider>
    );
  }
);
